import React, { useState } from 'react';
import BaseModal from '../baseModal';
import { useConnect } from '@stacks/connect-react';
import { principalCV } from '@stacks/transactions/dist/clarity/types/principalCV';
import { clientNetwork, profileContract, stacksExplorer, stacksExplorerParam } from "../../lib/constants";
import TermsOfService from './TermsOfService';
import { MdConstruction } from "react-icons/md";
import { network, authenticatedUserAddress } from "../../services/auth";
import { AnchorMode } from '@stacks/transactions';
import './style.scss';

function UserContractDeployModal({
    show, setShow,
    txId, setTxId,
    userContractStatus,
    setUserContractStatus,
    openConfirmModal,
    setTx_Id,
    userSettings
}) {
    const { doContractCall, doContractDeploy } = useConnect();
    const [openTerms, setOpenTerms] = useState(false);

    const userAddress = authenticatedUserAddress({ network: clientNetwork });

    async function deployUserContract() {
        const body = await (await fetch(`/contracts/${profileContract}.clar`)).text();
        doContractDeploy({
            contractName: profileContract,
            codeBody: body.toString(),
            network: network({ network: clientNetwork }),
            anchorMode: AnchorMode.Any,
            onFinish: ({ txId: tx }) => {
                setTxId(tx);
                setTx_Id(tx);
                setOpenTerms(false);
                setUserContractStatus('mempool');
                openConfirmModal(true);
            }
        });
    }

    const userContractActivate = () => {
        const txOptions = {
            contractAddress: userAddress,
            contractName: profileContract,
            functionName: 'activate-member',
            functionArgs: [principalCV(`${userAddress}.${profileContract}`)],
            network: network({ network: clientNetwork }),
            onFinish: ({ txId: tx }) => {
                setTxId(tx);
                setTx_Id(tx);
                setOpenTerms(false);
                setUserContractStatus('activationPending');
                openConfirmModal(true);
            }
        }
        doContractCall(txOptions)
    }

    const handleClose = () => {
        setShow(false);
    }

    return (
        <>
            <BaseModal show={show} setShow={setShow} handleClose={handleClose} >
                <div className="notification">
                    <div className="notification-content">
                        <h4><MdConstruction />Under Maintenance<MdConstruction /></h4>
                        <p>We are currently performing essential maintenance for Derupt functionality to enhance its performance and improve your user experience. During this time, services are temporarily unavailable.
                            We apologize for any inconvenience and appreciate your understanding. Our team is working diligently to complete this update as quickly as possible!</p>
                    </div>
                </div>
                {/* <div id="activate-deploy-form" className="broadcast-modal-tx__buttons">
                    <p className='contract-deploy-text'>Your <a href={`https://docs.derupt.io/latest/contracts/.${profileContract}`} target='blank'>smart contract</a></p>
                    {userContractStatus === "notfound" ? <p className='contract-deploy-text'>is Ready to Deploy.</p> : null}
                    {userContractStatus === 'failed' ? <p className='contract-deploy-text'>Deployment failed, try again.</p> : null}
                    {userContractStatus === 'mempool' ? <p className='contract-deploy-text'>Deployment <a href={`${userSettings?.stacksExplorer || stacksExplorer}/txid/${txId}${stacksExplorerParam}`} target='blank'>pending</a>.</p> : null}
                    {userContractStatus === 'activationPending' ? <p className='contract-deploy-text'>Activation <a href={`${userSettings?.stacksExplorer || stacksExplorer}/txid/${txId}${stacksExplorerParam}`} target='blank'>pending</a>.</p> : null}
                    {userContractStatus === false ? <p className='contract-deploy-text'>is Ready to Activate.</p> : null}
                    <button className="button" disabled={userContractStatus === 'failed' || userContractStatus === 'notfound' ? false : true} onClick={() => setOpenTerms(true)} >Deploy</button>
                    <button className="button" disabled={userContractStatus ? true : false} onClick={() => setOpenTerms(true)} >Activate</button>
                </div> */}

            </BaseModal>
            {openTerms && <TermsOfService show={openTerms} close={() => setOpenTerms(false)} action={typeof (userContractStatus) === 'string' ? () => deployUserContract() : () => userContractActivate()} />}
        </>
    );
}
export default UserContractDeployModal;
